module.exports = __webpack_public_path__ + "img/twitter-icon.e6874a6d.svg";